<template>
  <div id="app">
    <div class="widewrapper masthead">
        <div class="container">
            <a id="logo" @click="home()">
                <img id='logo_img' style="width:260px;border-radius: 10px;" src="../static/img/logo.png" alt="clean Blog">
            </a>

            <div id="mobile-nav-toggle" class="pull-right">
                <a href="#" @click="show()">
                    <i class="fa fa-bars"></i>
                </a>
            </div>

            <nav class="pull-right clean-nav">
                <!-- 展开添加class in -->
                <div :class="{ collapse: true, collapse: true, in: isshow }">
                    <ul class="nav nav-pills navbar-nav">
                        <li>
                            <a class='navi' @click="home()">
                                <span class='navi-text' @click="after()">主页</span>
                            </a>
                        </li>
                        <li>
                            <router-link class='navi' to="me">
                                <span class='navi-text' @click="after()">我的</span>
                            </router-link>
                        </li>
                        <li>
                            <router-link class='navi' to="contact">
                                <span class='navi-text' @click="after()">联系</span>
                            </router-link>
                        </li>                        
                    </ul>
                </div>
            </nav>        

        </div>
    </div>

    <div class="widewrapper subheader">
        <div class="container">
            <div class="clean-breadcrumb">
                <a @click="home()">主页</a>
            </div>

            <div class="clean-searchbox">
                <input class="searchfield" type="text" v-model="search" placeholder="关键字">
                <button class="searchbutton" type="button" @click="dosearch()">
                    <i class="fa fa-search"></i>
                </button>
            </div>
        </div>
    </div>

    <router-view/>

    <footer class="footer pt-50">
      <div class="widewrapper footer">
      <div class="container">
        <div style="height:10px"></div>
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-6 mb-30"> 
            <h4 class="footer-item-title">关于我</h4>
            <div class="footer-about">
              <p class="mb-0">前 360 资深研发<br/>分享些有趣好玩的东西</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 mb-30"> 
            <h4 class="footer-item-title">分类</h4>
            <ul class="footer-link">
              <li> 大模型</a></li>
              <li> Python</a></li>
              <li> Golang</a></li>
            </ul>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 mb-30"> 
            <h4 class="footer-item-title">联系</h4>
            <ul class="footer-contact">
              <li><span>公众号:</span> 1bit范儿</li>
              <li><span>邮箱:</span> 912504432@qq.com</li>
              <li><span>电话:</span><a href="tel:18513417479"> 18513417479</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div style="height:5px"></div>
      <div class="copyright-footer text-center mt-20">
        <div class="container">
          <p class="mb-0"><a target="_blank" href="https://beian.miit.gov.cn" class="text-white">京ICP备16049573号</a></p>
        </div>
      </div>
      </div>
    </footer>

  </div>
</template>

<script src="/static/js/jquery.min.js"></script>
<script src="/static/js/bootstrap.min.js"></script>
<script src="/static/js/modernizr.js"></script>
<script>
export default {
  name: 'App',
  data () {
      return {
          isshow: true,
          search: ''
      }
  },
  mounted : function(){
    var width = document.documentElement.clientWidth;
    var logo_img = document.getElementById('logo_img');
    logo_img.style.width = width > 375 ? '260px' : '200px';
    this.isshow = width > 375 ? true : false;
  },
  methods : {
      show: function () {
          this.isshow = !this.isshow;
      },
      after: function () {
          var width = document.documentElement.clientWidth;
          this.isshow = width > 375 ? true : false;
      },
      home: function () {
          this.$router.push({
            name: 'Jump'
          })
      },
      dosearch: function () {
          var search = this.search;
          if (search == '') {
              return false;
          }
          this.$router.push({
            name: 'Jump',
            query: {
                search: search
            }
          })
      }
  }
}
</script>

<style>
@import '../static/css/bootstrap.min.css';
@import '../static/css/font-awesome/css/font-awesome.min.css';
@import '../static/css/style.css';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue